import { render, staticRenderFns } from "./Terminos.vue?vue&type=template&id=a7d43d3e&"
import script from "./Terminos.vue?vue&type=script&lang=ts&"
export * from "./Terminos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports